const l = `<svg width="32" height="32" viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg">
    <g fill="none" fill-rule="evenodd">
        <circle cx="16" cy="16" r="16" />
        <path
            d="M22.829 9.802L20.39 22.507c-.17.903-.665 1.12-1.345.704l-3.71-3.034-1.783 1.913c-.205.23-.377.417-.743.417l.25-4.197 6.883-6.864c.306-.308-.063-.456-.465-.187L10.98 17.2l-3.674-1.29c-.788-.247-.797-.852.179-1.29l14.311-6.109c.656-.326 1.281.178 1.034 1.29z"
            fill="currentColor" fill-rule="nonzero" />
    </g>
</svg>`;
export {
  l as default
};
//# sourceMappingURL=telegram.es.Bc3efEt7.js.map
